/**
 * Builds the URL for backend fetch() calls.
 *
 * On CRA dev (port 3000), uses relative `/api/...` so the dev server proxies to
 * Express (see package.json "proxy"). Otherwise POST /api/* hits the React
 * server and returns "Cannot POST /api/spotSubmit".
 *
 * If REACT_APP_BACKEND_URL points at a real API host (e.g. API Gateway), that
 * full URL is still used in dev.
 */
export function apiUrl(endpoint) {
  const path = endpoint.startsWith('/') ? endpoint : `/${endpoint}`;
  const base = (process.env.REACT_APP_BACKEND_URL || '').trim().replace(/\/+$/, '');

  const craDev =
    process.env.NODE_ENV === 'development' &&
    typeof window !== 'undefined' &&
    window.location.port === '3000';

  // Always use relative /api on CRA dev server so package.json "proxy" forwards
  // to Express. A direct http://localhost:5000/api URL skips the proxy; if :5000
  // is down or wrong, the browser can still hit :3000 and show "Cannot POST /api/...".
  if (craDev) {
    return `/api${path}`;
  }

  if (!base) {
    return `/api${path}`;
  }

  return `${base}${path}`;
}
